const DEFAULT_TITLE = 'Ocorreu um erro inesperado.'
const NETWORK_TITLE = 'Falha de comunicação com o servidor.'
const OFFLINE_TITLE = 'Sem conexão com a internet.'
/* eslint-disable */
const flattenErrors = errors => {
  if (!errors || typeof errors !== 'object') return null
  const values = Object.values(errors)
  if (!values.length) return null
  const first = values.find(item => Array.isArray(item) && item.length > 0)
  if (first && first[0]) return first[0]
  if (typeof values[0] === 'string') return values[0]
  return null
}

const resolveProblemDetails = (data, status) => {
  const title = data.title || data.error || DEFAULT_TITLE
  const detailFromErrors = flattenErrors(data.errors)
  const detail = data.detail || data.message || detailFromErrors || (typeof data === 'string' ? data : null)
  const traceId = data.traceId || data['trace-id'] || data['traceId'] || data['request-id']
  return {
    title,
    detail,
    status: data.status || status,
    traceId,
    isApiError: true,
  }
}

const resolveNetworkError = error => {
  const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true
  return {
    title: isOnline ? NETWORK_TITLE : OFFLINE_TITLE,
    detail: error?.message || null,
    status: undefined,
    traceId: undefined,
    isApiError: false,
  }
}

const resolveUnexpected = error => ({
  title: error?.message || DEFAULT_TITLE,
  detail: null,
  status: undefined,
  traceId: undefined,
  isApiError: false,
})

export default function resolveError(error) {
  if (error && error._resolved) {
    return error._resolved
  }

  if (!error) {
    return resolveUnexpected(error)
  }

  const response = error.response
  if (response && response.data) {
    const resolved = resolveProblemDetails(response.data, response.status)
    error._resolved = resolved
    return resolved
  }

  if (error.request) {
    const resolved = resolveNetworkError(error)
    error._resolved = resolved
    return resolved
  }

  const resolved = resolveUnexpected(error)
  error._resolved = resolved
  return resolved
}
